import React from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { CircularAvatar } from '../../../commons';
import { Link } from 'react-router-dom';
import { DocumentsLinkType } from '../../../../redux/listing/listingTypes';
import { resetChildFoldersList } from '../../../../redux/fileManager';

type AppProps = {
  linkText?: string;
  commenterName?: string;
  linkNote?: string;
  dateTime?: string;
  data: DocumentsLinkType;
  client_code: any;
  company_name: string;
}

const LinkDetails = ({
  data,
  linkText,
  commenterName,
  linkNote,
  dateTime,
  client_code,
  company_name
}: AppProps) => {

  const dispatchAction = useDispatch();

  const finalLink = {
    pathname: `${data?.link}?client_code=${client_code}&company_name=${company_name}`,
    state: { company_name, client_code }
  };

  const handleSetLocalStorageData = () => {
    const setBool = { redirectUrl: true }
    // localStorage.setItem("client_code", client_code);
    // localStorage.setItem('company_name', company_name);
    localStorage.setItem('redirectUrl', JSON.stringify(setBool));
    dispatchAction(resetChildFoldersList());
  }
  return (
    <div className='py-1'>
      <div className="d-flex justify-content-between align-items-center">
        <div className='d-flex flex-row align-items-center'>
          <CircularAvatar name={commenterName} />
          <div className="d-flex flex-column ml-2">
            <p className='mb-0 commenter-text'>
              {commenterName && commenterName.length > 1 ? commenterName : 'Anonymous'}
            </p>
            <span className='due-date-text mb-0'>
              {moment(dateTime).local().format('DD-MM-YYYY, h:mm a')}
              {/* {moment.utc(dateTime).local().format('DD-MM-YY, h:mm a')} */}
            </span>
          </div>
        </div>
        <div className='d-flex align-items-center'>

        </div>
      </div>
      {<p className='comment-text'>
        {linkNote}
      </p>}
      <Link 
      onClick={() => handleSetLocalStorageData()} 
      to={finalLink} target='_blank' style={{ textDecoration: 'none' }}>
        <span className='comment-text' style={{
          fontSize: '14px',
          color: '#d43',
          fontWeight: 500,
          cursor: 'pointer',
        }} >VIEW LINKED DOCUMENTS</span>
      </Link>
      <hr />
    </div>
  )
};
export default LinkDetails;